// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapContainer_wrapper__wKpBg","wrapper_full":"MapContainer_wrapper_full__1waz5"};